// import React, { useState } from "react";
// import "./Image.css";
// import FullScreenSlider from "./FullScreenSlider";
// import {products} from "../../Product"; // Import products from products.js

// function Image() {
//   const [isSliderOpen, setIsSliderOpen] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);

//   const openSlider = (index) => {
//     setCurrentImageIndex(index);
//     setIsSliderOpen(true);
//   };

//   const closeSlider = () => {
//     setIsSliderOpen(false);
//   };

//   // Only use the "img" property
//   const images = products.map((product) => product.imgg).filter(Boolean);

//   return (
//     <section className="gallery-container" aria-labelledby="gallery-title">
//       <div className="images-grid" role="list">
//         {images.map((imgSrc, index) => (
//           <div
//             key={index}
//             className="image-wrapper"
//             onClick={() => openSlider(index)}
//             role="listitem"
//             tabIndex={0}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" || e.key === " ") openSlider(index);
//             }}
//             aria-label={`Open fullscreen slider for image ${index + 1}`}
//           >
//             <img
//               src={imgSrc}
//               alt={`Product image ${index + 1}`}
//               loading="lazy"
//               className="gallery-image"
//             />
//           </div>
//         ))}
//       </div>

//       {isSliderOpen && (
//         <FullScreenSlider
//           images={images} // pass only the "img" images
//           initialIndex={currentImageIndex}
//           onClose={closeSlider}
//         />
//       )}
//     </section>
//   );
// }

// export default Image;



// import React, { useState, useEffect } from "react";
// import FullScreenSlider from "./FullScreenSlider";
// import { products } from "../../Product";
// import { 
//   faHeart, 
//   faExpand, 
//   faEye,
//   faFilter,
//   faSearch,
//   faTimes,
//   faTh,
//   faThLarge,
//   faChevronUp,
//   faBars,
//   faSlidersH,
//   faImages
// } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// // IMPORTANT: Renamed from 'Image' to 'ImageGallery' to avoid conflict
// function ImageGallery() {
//   const [isSliderOpen, setIsSliderOpen] = useState(false);
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const [hoveredIndex, setHoveredIndex] = useState(null);
//   const [likedImages, setLikedImages] = useState({});
//   const [viewMode, setViewMode] = useState('grid');
//   const [filterCategory, setFilterCategory] = useState('all');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showScrollTop, setShowScrollTop] = useState(false);
//   const [showMobileMenu, setShowMobileMenu] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   // Site metadata for SEO
//   const siteMetadata = {
//     title: "Image Gallery | Visual Showcase Collection",
//     description: "Browse our curated collection of high-quality images. Discover, filter, and explore visual content across various categories.",
//     siteUrl: "https://yourdomain.com",
//     author: "Your Company Name",
//     keywords: ["gallery", "images", "visual content", "photography", "art"],
//     social: {
//       twitter: "@yourtwitterhandle"
//     }
//   };

//   // Extract categories
//   const categories = ['all', ...new Set(products.map(p => p.category).filter(Boolean))];

//   // Filter products - moved BEFORE useEffect
//   const filteredProducts = products.filter(product => {
//     if (filterCategory !== 'all' && product.category !== filterCategory) return false;
//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       return (
//         product.title?.toLowerCase().includes(term) ||
//         product.description?.toLowerCase().includes(term) ||
//         product.category?.toLowerCase().includes(term)
//       );
//     }
//     return true;
//   });

//   // Structured data for the gallery - uses filteredProducts
//   const structuredData = {
//     "@context": "https://schema.org",
//     "@type": "ImageGallery",
//     "name": "Visual Image Gallery",
//     "description": siteMetadata.description,
//     "url": `${siteMetadata.siteUrl}/gallery`,
//     "image": filteredProducts.map(product => ({
//       "@type": "ImageObject",
//       "contentUrl": product.imgg,
//       "name": product.title || "Gallery Image",
//       "description": product.description || "",
//       "keywords": product.category ? [product.category] : []
//     })).slice(0, 10), // Limit to first 10 for performance
//     "author": {
//       "@type": "Organization",
//       "name": siteMetadata.author
//     },
//     "datePublished": "2024-01-01",
//     "dateModified": new Date().toISOString().split('T')[0]
//   };

//   // Handle responsive breakpoints
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Handle scroll for back to top button
//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollTop(window.scrollY > 300);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Preload critical images - now filteredProducts is defined
//   useEffect(() => {
//     const preloadImages = () => {
//       // Only preload if we have filtered products
//       if (filteredProducts && filteredProducts.length > 0) {
//         filteredProducts.slice(0, 4).forEach(product => {
//           const img = new Image();
//           img.src = product.imgg;
//         });
//       }
//     };
//     preloadImages();
//   }, [filteredProducts]); // Add dependency to re-preload when filteredProducts changes

//   const openSlider = (index) => {
//     setCurrentImageIndex(index);
//     setIsSliderOpen(true);
//   };

//   const closeSlider = () => setIsSliderOpen(false);

//   const toggleLike = (e, index) => {
//     e.stopPropagation();
//     setLikedImages(prev => ({
//       ...prev,
//       [index]: !prev[index]
//     }));
//   };

//   return (
//     <>
//       {/* SEO Meta Tags (for SPA, these would ideally be in Head component) */}
//       <Helmet>
//         <title>{siteMetadata.title}</title>
//         <meta name="description" content={siteMetadata.description} />
//         <meta name="keywords" content={siteMetadata.keywords.join(', ')} />
//         <meta name="author" content={siteMetadata.author} />
//         <meta property="og:title" content={siteMetadata.title} />
//         <meta property="og:description" content={siteMetadata.description} />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={`${siteMetadata.siteUrl}/gallery`} />
//         <meta property="og:image" content={filteredProducts[0]?.imgg || `${siteMetadata.siteUrl}/og-image.jpg`} />
//         <meta property="og:site_name" content={siteMetadata.author} />
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:site" content={siteMetadata.social.twitter} />
//         <meta name="twitter:title" content={siteMetadata.title} />
//         <meta name="twitter:description" content={siteMetadata.description} />
//         <meta name="twitter:image" content={filteredProducts[0]?.imgg || `${siteMetadata.siteUrl}/twitter-image.jpg`} />
//         <link rel="canonical" href={`${siteMetadata.siteUrl}/gallery`} />
//         <meta name="robots" content="index, follow, max-image-preview:large" />
//         <script type="application/ld+json">
//           {JSON.stringify(structuredData)}
//         </script>
//       </Helmet>

//       <div className="min-h-screen bg-gradient-to-br from-orange-50 to-white relative overflow-hidden" itemScope itemType="https://schema.org/ImageGallery">
//         {/* Orange Gradient Background Effect */}
//         <div className="fixed inset-0 pointer-events-none">
//           <div className="absolute top-0 left-0 w-full h-96 bg-gradient-to-b from-orange-100/30 to-transparent"></div>
//           <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-t from-orange-50/20 to-transparent rounded-full translate-x-1/3 translate-y-1/3"></div>
//         </div>

//         {/* Main Header */}
//         <header role="banner" className=" z-50 shadow-lg border-b border-orange-100">
//           {/* Breadcrumb Navigation */}
          

//           {/* Control Bar */}
//           <div className="bg-white">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
//               <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
//                 {/* Search Bar */}
//                 <div className="relative flex-1 max-w-2xl">
//                   <label htmlFor="gallery-search" className="sr-only">Search gallery images</label>
//                   <div className="relative">
//                     <input
//                       id="gallery-search"
//                       type="search"
//                       placeholder="Search images by title, category or description..."
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                       className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-300"
//                       aria-label="Search through gallery images"
//                     />
//                     <FontAwesomeIcon 
//                       icon={faSearch} 
//                       className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500"
//                       aria-hidden="true"
//                     />
//                     {searchTerm && (
//                       <button
//                         onClick={() => setSearchTerm('')}
//                         className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-orange-500 transition-colors duration-300"
//                         aria-label="Clear search"
//                       >
//                         <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 {/* Control Buttons Group */}
//                 <div className="flex items-center gap-3">
//                   {/* View Toggle */}
//                   <fieldset className="flex bg-gray-100 rounded-xl p-1 border border-gray-200">
//                     <legend className="sr-only">Gallery view mode</legend>
//                     <button
//                       type="button"
//                       onClick={() => setViewMode('grid')}
//                       aria-pressed={viewMode === 'grid'}
//                       className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2 ${
//                         viewMode === 'grid'
//                           ? 'bg-white shadow-sm text-orange-600 border border-orange-100'
//                           : 'text-gray-600 hover:text-orange-600 hover:bg-white/50'
//                       }`}
//                       aria-label="Switch to grid view"
//                     >
//                       <FontAwesomeIcon icon={faTh} className="text-sm" aria-hidden="true" />
//                       <span className="hidden sm:inline text-sm font-medium">Grid</span>
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => setViewMode('masonry')}
//                       aria-pressed={viewMode === 'masonry'}
//                       className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2 ${
//                         viewMode === 'masonry'
//                           ? 'bg-white shadow-sm text-orange-600 border border-orange-100'
//                           : 'text-gray-600 hover:text-orange-600 hover:bg-white/50'
//                       }`}
//                       aria-label="Switch to masonry view"
//                     >
//                       <FontAwesomeIcon icon={faThLarge} className="text-sm" aria-hidden="true" />
//                       <span className="hidden sm:inline text-sm font-medium">Masonry</span>
//                     </button>
//                   </fieldset>

//                   {/* Filter Button */}
//                   <div className="relative group">
//                     <button
//                       type="button"
//                       className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
//                       aria-label="Open filter options"
//                       aria-expanded="false"
//                     >
//                       <FontAwesomeIcon icon={faFilter} aria-hidden="true" />
//                       <span className="hidden sm:inline font-medium">Filter</span>
//                     </button>
                    
//                     {/* Filter Dropdown */}
//                     <div role="dialog" aria-label="Filter by category" className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl border border-orange-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
//                       <div className="p-4">
//                         <label htmlFor="category-filter" className="block text-sm font-medium text-gray-700 mb-2">
//                           Category
//                         </label>
//                         <select
//                           id="category-filter"
//                           value={filterCategory}
//                           onChange={(e) => setFilterCategory(e.target.value)}
//                           className="w-full px-3 py-2 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                           aria-label="Select category to filter by"
//                         >
//                           {categories.map(cat => (
//                             <option key={cat} value={cat}>
//                               {cat === 'all' ? 'All Categories' : cat}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Filter Chips */}
//               <div className="mt-3 flex flex-wrap gap-2" role="list" aria-label="Active filters">
//                 {filterCategory !== 'all' && (
//                   <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-orange-100 text-orange-700 rounded-full text-sm" role="listitem">
//                     {filterCategory}
//                     <button 
//                       onClick={() => setFilterCategory('all')} 
//                       className="ml-1 hover:text-orange-900"
//                       aria-label={`Remove ${filterCategory} filter`}
//                     >
//                       <FontAwesomeIcon icon={faTimes} className="text-xs" aria-hidden="true" />
//                     </button>
//                   </span>
//                 )}
//                 {searchTerm && (
//                   <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm" role="listitem">
//                     Search: "{searchTerm}"
//                     <button 
//                       onClick={() => setSearchTerm('')} 
//                       className="ml-1 hover:text-gray-900"
//                       aria-label="Clear search term"
//                     >
//                       <FontAwesomeIcon icon={faTimes} className="text-xs" aria-hidden="true" />
//                     </button>
//                   </span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* Mobile Menu */}
//           {showMobileMenu && (
//             <div className="md:hidden fixed inset-0 top-16 bg-black/50 backdrop-blur-sm z-40 animate-fade-in">
//               <div className="bg-white rounded-b-2xl shadow-2xl mx-4 mt-2 p-6 animate-slide-down" role="dialog" aria-label="Mobile menu">
//                 <div className="space-y-4">
//                   <div className="pb-4 border-b border-gray-100">
//                     <label htmlFor="mobile-category-filter" className="block text-sm font-medium text-gray-700 mb-2">
//                       Category Filter
//                     </label>
//                     <select
//                       id="mobile-category-filter"
//                       value={filterCategory}
//                       onChange={(e) => setFilterCategory(e.target.value)}
//                       className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
//                     >
//                       {categories.map(cat => (
//                         <option key={cat} value={cat}>
//                           {cat === 'all' ? 'All Categories' : cat}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div className="flex items-center justify-between" aria-label="Gallery statistics">
//                     <div>
//                       <div className="text-2xl font-bold text-orange-600" aria-label={`${filteredProducts.length} images showing`}>
//                         {filteredProducts.length}
//                       </div>
//                       <div className="text-sm text-gray-500">Images showing</div>
//                     </div>
//                     <div>
//                       <div className="text-2xl font-bold text-orange-600" aria-label={`${Object.values(likedImages).filter(Boolean).length} liked images`}>
//                         {Object.values(likedImages).filter(Boolean).length}
//                       </div>
//                       <div className="text-sm text-gray-500">Liked</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </header>

//         {/* Main Content */}
//         <main id="main-content" role="main" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//           {/* Page Heading */}
         

//           {/* Gallery Grid */}
//           {filteredProducts.length > 0 ? (
//             <section 
//               aria-label="Image gallery" 
//               itemScope 
//               itemType="https://schema.org/ItemList"
//               className={`grid gap-6 ${
//                 viewMode === 'grid'
//                   ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
//                   : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
//               }`}
//             >
//               {filteredProducts.map((product, index) => (
//                 <article
//                   key={index}
//                   itemScope
//                   itemType="https://schema.org/ImageObject"
//                   className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 animate-fade-in border border-gray-100"
//                   onMouseEnter={() => setHoveredIndex(index)}
//                   onMouseLeave={() => setHoveredIndex(null)}
//                   onClick={() => openSlider(index)}
//                   style={{ animationDelay: `${index * 100}ms` }}
//                   role="article"
//                   aria-labelledby={`image-title-${index}`}
//                 >
//                   {/* Image Container */}
//                   <div className="relative overflow-hidden aspect-square">
//                     <img
//                       src={product.imgg}
//                       alt={product.title || `Gallery image ${index + 1}`}
//                       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                       loading={index < 4 ? "eager" : "lazy"}
//                       width="400"
//                       height="400"
//                       itemProp="contentUrl"
//                     />

//                     {/* Orange Gradient Overlay */}
//                     <div className="absolute inset-0 bg-gradient-to-t from-orange-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

//                     {/* Top Actions */}
//                     <div className="absolute top-3 right-3 flex gap-2">
//                       <button
//                         type="button"
//                         onClick={(e) => toggleLike(e, index)}
//                         className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
//                         aria-label={likedImages[index] ? "Unlike this image" : "Like this image"}
//                         aria-pressed={likedImages[index]}
//                       >
//                         <FontAwesomeIcon
//                           icon={faHeart}
//                           className={`text-sm ${
//                             likedImages[index] ? 'text-red-500 animate-heartbeat' : 'text-gray-600'
//                           }`}
//                           aria-hidden="true"
//                         />
//                       </button>
//                       <button
//                         type="button"
//                         className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
//                         onClick={() => openSlider(index)}
//                         aria-label="View fullscreen"
//                       >
//                         <FontAwesomeIcon icon={faExpand} className="text-sm text-gray-600" aria-hidden="true" />
//                       </button>
//                     </div>

//                     {/* Orange Category Badge */}
//                     {product.category && (
//                       <div className="absolute top-3 left-3">
//                         <span className="px-3 py-1.5 bg-orange-500/90 backdrop-blur-sm text-white text-xs font-semibold rounded-full shadow-lg" itemProp="keywords">
//                           {product.category}
//                         </span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Image Info Footer */}
//                   <div className="p-4">
//                     <div className="flex items-center justify-between">
//                       <div className="flex-1 min-w-0">
//                         <h3 
//                           id={`image-title-${index}`} 
//                           className="font-medium text-gray-800 truncate"
//                           itemProp="name"
//                         >
//                           {product.title}
//                         </h3>
//                         <div className="flex items-center gap-2 mt-1">
//                           {product.category && (
//                             <span className="text-xs px-2 py-0.5 bg-orange-50 text-orange-700 rounded">
//                               {product.category}
//                             </span>
//                           )}
//                           {likedImages[index] && (
//                             <span className="text-xs text-red-500 flex items-center gap-1">
//                               <FontAwesomeIcon icon={faHeart} className="text-xs" aria-hidden="true" />
//                               Liked
//                             </span>
//                           )}
//                         </div>
//                         {product.description && (
//                           <p className="text-sm text-gray-600 mt-2 line-clamp-2" itemProp="description">
//                             {product.description}
//                           </p>
//                         )}
//                       </div>
//                       <button
//                         type="button"
//                         className="w-8 h-8 bg-orange-50 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-100 hover:scale-110 transition-all duration-300"
//                         onClick={() => openSlider(index)}
//                         aria-label={`View details of ${product.title || 'image'}`}
//                       >
//                         <FontAwesomeIcon icon={faEye} className="text-sm" aria-hidden="true" />
//                       </button>
//                     </div>
//                   </div>
//                 </article>
//               ))}
//             </section>
//           ) : (
//             /* Empty State */
//             <section className="text-center py-20" aria-labelledby="empty-state-title">
//               <div className="w-32 h-32 bg-gradient-to-br from-orange-100 to-orange-50 rounded-3xl flex items-center justify-center mx-auto mb-8 border-2 border-orange-200" aria-hidden="true">
//                 <FontAwesomeIcon icon={faSearch} className="text-5xl text-orange-400" />
//               </div>
//               <h2 id="empty-state-title" className="text-2xl font-bold text-gray-800 mb-3">
//                 No images found
//               </h2>
//               <p className="text-gray-600 mb-8 max-w-md mx-auto">
//                 Try adjusting your search terms or filter categories to find what you're looking for.
//               </p>
//               <div className="flex flex-wrap gap-3 justify-center">
//                 <button
//                   type="button"
//                   onClick={() => setSearchTerm('')}
//                   className="px-5 py-2.5 bg-orange-500 text-white font-medium rounded-xl hover:bg-orange-600 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
//                 >
//                   Clear Search
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSearchTerm('');
//                     setFilterCategory('all');
//                   }}
//                   className="px-5 py-2.5 bg-white text-orange-600 font-medium rounded-xl border border-orange-200 hover:bg-orange-50 hover:shadow-md transition-all duration-300"
//                 >
//                   Reset All Filters
//                 </button>
//               </div>
//             </section>
//           )}

//           {/* Pagination (Optional - Add if you have many images) */}
//           {filteredProducts.length > 0 && filteredProducts.length < products.length && (
//             <nav aria-label="Gallery navigation" className="mt-12">
//               <p className="text-center text-gray-600 mb-4">
//                 Showing {filteredProducts.length} of {products.length} images
//               </p>
//             </nav>
//           )}
//         </main>

//         {/* Scroll to Top Button */}
//         <button
//           type="button"
//           onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
//           className={`fixed bottom-6 right-6 w-14 h-14 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-110 transition-all duration-300 ${
//             showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
//           }`}
//           aria-label="Scroll back to top"
//         >
//           <FontAwesomeIcon icon={faChevronUp} aria-hidden="true" />
//         </button>
        

//         {/* Full Screen Slider */}
//         {isSliderOpen && (
//           <FullScreenSlider
//             images={filteredProducts.map(p => p.imgg)}
//             initialIndex={currentImageIndex}
//             onClose={closeSlider}
//           />
//         )}
//       </div>
//     </>
//   );
// }

// // Helper component for meta tags (if not using react-helmet, you can use react-helmet-async)
// const Helmet = ({ children }) => {
//   // In a real app, use react-helmet or similar
//   return null;
// };

// // IMPORTANT: Update the export to match the new component name
// export default ImageGallery;


import React, { useState, useEffect } from "react";
import FullScreenSlider from "./FullScreenSlider";
import { products } from "../../Product";
import { 
  faHeart, 
  faExpand, 
  faEye,
  faFilter,
  faSearch,
  faTimes,
  faTh,
  faThLarge,
  faChevronUp,
  faBars,
  faSlidersH,
  faImages
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Home/theme.css"; // Import the CSS file

// IMPORTANT: Renamed from 'Image' to 'ImageGallery' to avoid conflict
function ImageGallery() {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [likedImages, setLikedImages] = useState({});
  const [viewMode, setViewMode] = useState('grid');
  const [filterCategory, setFilterCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Add font styles to document head - MOVED INSIDE COMPONENT
  useEffect(() => {
    // Add Bell MT and Inter fonts
    const style = document.createElement('style');
    style.textContent = `
      @import url('https://fonts.cdnfonts.com/css/bell-mt');
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
      
      .bell-mt-primary {
        font-family: 'Bell MT', serif !important;
      }
      
      .inter-secondary {
        font-family: 'Inter', sans-serif !important;
      }
      
      body {
        font-family: 'Inter', sans-serif;
      }
      
      h1, h2, h3, h4, h5, h6, .bell-mt-text {
        font-family: 'Bell MT', serif;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Site metadata for SEO
  const siteMetadata = {
    title: "Image Gallery | Visual Showcase Collection",
    description: "Browse our curated collection of high-quality images. Discover, filter, and explore visual content across various categories.",
    siteUrl: "https://yourdomain.com",
    author: "Your Company Name",
    keywords: ["gallery", "images", "visual content", "photography", "art"],
    social: {
      twitter: "@yourtwitterhandle"
    }
  };

  // Extract categories
  const categories = ['all', ...new Set(products.map(p => p.category).filter(Boolean))];

  // Filter products - moved BEFORE useEffect
  const filteredProducts = products.filter(product => {
    if (filterCategory !== 'all' && product.category !== filterCategory) return false;
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      return (
        product.title?.toLowerCase().includes(term) ||
        product.description?.toLowerCase().includes(term) ||
        product.category?.toLowerCase().includes(term)
      );
    }
    return true;
  });

  // Structured data for the gallery - uses filteredProducts
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ImageGallery",
    "name": "Visual Image Gallery",
    "description": siteMetadata.description,
    "url": `${siteMetadata.siteUrl}/gallery`,
    "image": filteredProducts.map(product => ({
      "@type": "ImageObject",
      "contentUrl": product.imgg,
      "name": product.title || "Gallery Image",
      "description": product.description || "",
      "keywords": product.category ? [product.category] : []
    })).slice(0, 10), // Limit to first 10 for performance
    "author": {
      "@type": "Organization",
      "name": siteMetadata.author
    },
    "datePublished": "2024-01-01",
    "dateModified": new Date().toISOString().split('T')[0]
  };

  // Handle responsive breakpoints
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle scroll for back to top button
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Preload critical images - now filteredProducts is defined
  useEffect(() => {
    const preloadImages = () => {
      // Only preload if we have filtered products
      if (filteredProducts && filteredProducts.length > 0) {
        filteredProducts.slice(0, 4).forEach(product => {
          const img = new Image();
          img.src = product.imgg;
        });
      }
    };
    preloadImages();
  }, [filteredProducts]); // Add dependency to re-preload when filteredProducts changes

  const openSlider = (index) => {
    setCurrentImageIndex(index);
    setIsSliderOpen(true);
  };

  const closeSlider = () => setIsSliderOpen(false);

  const toggleLike = (e, index) => {
    e.stopPropagation();
    setLikedImages(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <>
      {/* SEO Meta Tags (for SPA, these would ideally be in Head component) */}
      <Helmet>
        <title>{siteMetadata.title}</title>
        <meta name="description" content={siteMetadata.description} />
        <meta name="keywords" content={siteMetadata.keywords.join(', ')} />
        <meta name="author" content={siteMetadata.author} />
        <meta property="og:title" content={siteMetadata.title} />
        <meta property="og:description" content={siteMetadata.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${siteMetadata.siteUrl}/gallery`} />
        <meta property="og:image" content={filteredProducts[0]?.imgg || `${siteMetadata.siteUrl}/og-image.jpg`} />
        <meta property="og:site_name" content={siteMetadata.author} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={siteMetadata.social.twitter} />
        <meta name="twitter:title" content={siteMetadata.title} />
        <meta name="twitter:description" content={siteMetadata.description} />
        <meta name="twitter:image" content={filteredProducts[0]?.imgg || `${siteMetadata.siteUrl}/twitter-image.jpg`} />
        <link rel="canonical" href={`${siteMetadata.siteUrl}/gallery`} />
        <meta name="robots" content="index, follow, max-image-preview:large" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <div 
        className="min-h-screen inter-secondary relative overflow-hidden" 
        itemScope 
        itemType="https://schema.org/ImageGallery"
        style={{
          background: "var(--gradient-bg)",
        }}
      >
        {/* Primary Color Gradient Background Effect */}
        <div className="fixed inset-0 pointer-events-none">
          <div 
            className="absolute top-0 left-0 w-full h-96 to-transparent"
            style={{
              // background: "linear-gradient(to bottom, var(--color-primary-100), transparent)",
            }}
          ></div>
          <div 
            className="absolute bottom-0 right-0 w-96 h-96 rounded-full translate-x-1/3 translate-y-1/3"
            style={{
              // background: "linear-gradient(to top, var(--color-primary-50), transparent)",
            }}
          ></div>
        </div>

        {/* Main Header */}
        <header 
          role="banner" 
          className="z-50 shadow-lg border-b"
          style={{
            borderColor: "var(--border-primary-20)",
          }}
        >
          {/* Control Bar */}
          <div className="bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                {/* Search Bar */}
                <div className="relative flex-1 max-w-2xl">
                  <label htmlFor="gallery-search" className="sr-only">Search gallery images</label>
                  <div className="relative">
                    <input
                      id="gallery-search"
                      type="search"
                      placeholder="Search images by title, category or description..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="w-full pl-12 pr-4 py-3 border-2 rounded-xl focus:outline-none focus:ring-2 transition-all duration-300 inter-secondary"
                      style={{
                        backgroundColor: "var(--color-gray-50)",
                        borderColor: "var(--border-medium)",
                      }}
                      aria-label="Search through gallery images"
                    />
                    <FontAwesomeIcon 
                      icon={faSearch} 
                      className="absolute left-4 top-1/2 -translate-y-1/2"
                      style={{ color: "var(--color-primary-500)" }}
                      aria-hidden="true"
                    />
                    {searchTerm && (
                      <button
                        onClick={() => setSearchTerm('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 transition-colors duration-300"
                        style={{ color: "var(--color-gray-400)" }}
                        aria-label="Clear search"
                      >
                        <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
                      </button>
                    )}
                  </div>
                </div>

                {/* Control Buttons Group */}
                <div className="flex items-center gap-3">
                  {/* View Toggle - UPDATED with Bell MT font */}
                 <fieldset 
          className="flex rounded-2xl p-1.5 backdrop-blur-sm border"
          style={{ 
            backgroundColor: "rgba(255,255,255,0.8)",
            borderColor: "var(--border-primary-20)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.02)"
          }}
        >
          <legend className="sr-only">Gallery view mode</legend>
          <button
            type="button"
            onClick={() => setViewMode('grid')}
            aria-pressed={viewMode === 'grid'}
            className={`px-5 py-2.5 rounded-xl transition-all duration-300 flex items-center gap-2 bell-mt-primary relative overflow-hidden group`}
            style={{
              backgroundColor: viewMode === 'grid' ? "var(--color-white)" : "transparent",
              color: viewMode === 'grid' ? "var(--color-primary-600)" : "var(--color-gray-600)",
              boxShadow: viewMode === 'grid' ? "0 4px 12px rgba(26,45,59,0.08)" : "none",
            }}
            aria-label="Switch to grid view"
          >
            {viewMode === 'grid' && (
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/5 to-transparent"></div>
            )}
            <FontAwesomeIcon icon={faTh} className="text-sm relative z-10" aria-hidden="true" />
            <span className="hidden sm:inline text-sm font-medium relative z-10">Grid</span>
          </button>
          <button
            type="button"
            onClick={() => setViewMode('masonry')}
            aria-pressed={viewMode === 'masonry'}
            className={`px-5 py-2.5 rounded-xl transition-all duration-300 flex items-center gap-2 bell-mt-primary relative overflow-hidden group`}
            style={{
              backgroundColor: viewMode === 'masonry' ? "var(--color-white)" : "transparent",
              color: viewMode === 'masonry' ? "var(--color-primary-600)" : "var(--color-gray-600)",
              boxShadow: viewMode === 'masonry' ? "0 4px 12px rgba(26,45,59,0.08)" : "none",
            }}
            aria-label="Switch to masonry view"
          >
            {viewMode === 'masonry' && (
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/5 to-transparent"></div>
            )}
            <FontAwesomeIcon icon={faThLarge} className="text-sm relative z-10" aria-hidden="true" />
            <span className="hidden sm:inline text-sm font-medium relative z-10">Masonry</span>
          </button>
        </fieldset>

                  {/* Filter Button */}
                  <div className="relative group">
                    <button
                      type="button"
                      className="flex items-center gap-2 px-4 py-2.5 text-white rounded-xl hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 bell-mt-primary"
                      style={{
                        background: "var(--gradient-primary)",
                      }}
                      aria-label="Open filter options"
                      aria-expanded="false"
                    >
                      <FontAwesomeIcon icon={faFilter} aria-hidden="true" />
                      <span className="hidden sm:inline font-medium">Filter</span>
                    </button>
                    
                    {/* Filter Dropdown */}
                    <div 
                      role="dialog" 
                      aria-label="Filter by category" 
                      className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50"
                      style={{
                        border: "1px solid var(--border-primary-20)",
                      }}
                    >
                      <div className="p-4">
                        <label htmlFor="category-filter" className="block text-sm font-medium mb-2 bell-mt-primary" style={{ color: "var(--color-primary-600)" }}>
                          Category
                        </label>
                        <select
                          id="category-filter"
                          value={filterCategory}
                          onChange={(e) => setFilterCategory(e.target.value)}
                          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 inter-secondary"
                          style={{
                            backgroundColor: "var(--color-gray-50)",
                            borderColor: "var(--border-medium)",
                          }}
                          aria-label="Select category to filter by"
                        >
                          {categories.map(cat => (
                            <option key={cat} value={cat} className="inter-secondary">
                              {cat === 'all' ? 'All Categories' : cat}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Filter Chips */}
              <div className="mt-3 flex flex-wrap gap-2" role="list" aria-label="Active filters">
                {filterCategory !== 'all' && (
                  <span 
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-sm bell-mt-primary"
                    style={{
                      backgroundColor: "var(--color-primary-100)",
                      color: "var(--color-primary-700)",
                    }}
                    role="listitem"
                  >
                    {filterCategory}
                    <button 
                      onClick={() => setFilterCategory('all')} 
                      className="ml-1"
                      style={{ color: "var(--color-primary-700)" }}
                      aria-label={`Remove ${filterCategory} filter`}
                    >
                      <FontAwesomeIcon icon={faTimes} className="text-xs" aria-hidden="true" />
                    </button>
                  </span>
                )}
                {searchTerm && (
                  <span 
                    className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-sm inter-secondary"
                    style={{
                      backgroundColor: "var(--color-gray-100)",
                      color: "var(--color-gray-700)",
                    }}
                    role="listitem"
                  >
                    Search: "{searchTerm}"
                    <button 
                      onClick={() => setSearchTerm('')} 
                      className="ml-1"
                      style={{ color: "var(--color-gray-700)" }}
                      aria-label="Clear search term"
                    >
                      <FontAwesomeIcon icon={faTimes} className="text-xs" aria-hidden="true" />
                    </button>
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {showMobileMenu && (
            <div className="md:hidden fixed inset-0 top-16 bg-black/50 backdrop-blur-sm z-40 animate-fade-in">
              <div className="bg-white rounded-b-2xl shadow-2xl mx-4 mt-2 p-6 animate-slide-down" role="dialog" aria-label="Mobile menu">
                <div className="space-y-4">
                  <div className="pb-4 border-b" style={{ borderColor: "var(--border-light)" }}>
                    <label htmlFor="mobile-category-filter" className="block text-sm font-medium mb-2 bell-mt-primary" style={{ color: "var(--color-gray-700)" }}>
                      Category Filter
                    </label>
                    <select
                      id="mobile-category-filter"
                      value={filterCategory}
                      onChange={(e) => setFilterCategory(e.target.value)}
                      className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 inter-secondary"
                      style={{
                        backgroundColor: "var(--color-gray-50)",
                        borderColor: "var(--border-medium)",
                      }}
                    >
                      {categories.map(cat => (
                        <option key={cat} value={cat} className="inter-secondary">
                          {cat === 'all' ? 'All Categories' : cat}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="flex items-center justify-between" aria-label="Gallery statistics">
                    <div>
                      <div 
                        className="text-2xl font-bold bell-mt-primary"
                        style={{ color: "var(--color-primary-600)" }}
                        aria-label={`${filteredProducts.length} images showing`}
                      >
                        {filteredProducts.length}
                      </div>
                      <div className="text-sm inter-secondary" style={{ color: "var(--color-gray-500)" }}>Images showing</div>
                    </div>
                    <div>
                      <div 
                        className="text-2xl font-bold bell-mt-primary"
                        style={{ color: "var(--color-primary-600)" }}
                        aria-label={`${Object.values(likedImages).filter(Boolean).length} liked images`}
                      >
                        {Object.values(likedImages).filter(Boolean).length}
                      </div>
                      <div className="text-sm inter-secondary" style={{ color: "var(--color-gray-500)" }}>Liked</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </header>

        {/* Main Content */}
        <main id="main-content" role="main" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Gallery Grid */}
          {filteredProducts.length > 0 ? (
            <section 
              aria-label="Image gallery" 
              itemScope 
              itemType="https://schema.org/ItemList"
              className={`grid gap-6 ${
                viewMode === 'grid'
                  ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
                  : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
              }`}
            >
              {filteredProducts.map((product, index) => (
                <article
                  key={index}
                  itemScope
                  itemType="https://schema.org/ImageObject"
                  className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 animate-fade-in border"
                  style={{
                    backgroundColor: "var(--color-white)",
                    borderColor: "var(--border-light)",
                    animationDelay: `${index * 100}ms`,
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => openSlider(index)}
                  role="article"
                  aria-labelledby={`image-title-${index}`}
                >
                  {/* Image Container */}
                  <div className="relative overflow-hidden aspect-square">
                    <img
                      src={product.imgg}
                      alt={product.title || `Gallery image ${index + 1}`}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      loading={index < 4 ? "eager" : "lazy"}
                      width="400"
                      height="400"
                      itemProp="contentUrl"
                    />

                    {/* Primary Color Gradient Overlay */}
                    <div 
                      className="absolute inset-0 opacity-0 group-hover:opacity-40 transition-opacity duration-500"
                      style={{
                        background: "linear-gradient(to top, var(--color-primary-900), transparent)",
                      }}
                    ></div>

                    {/* Top Actions */}
                    <div className="absolute top-3 right-3 flex gap-2">
                      <button
                        type="button"
                        onClick={(e) => toggleLike(e, index)}
                        className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
                        aria-label={likedImages[index] ? "Unlike this image" : "Like this image"}
                        aria-pressed={likedImages[index]}
                      >
                        <FontAwesomeIcon
                          icon={faHeart}
                          className={`text-sm ${
                            likedImages[index] ? 'animate-heartbeat' : ''
                          }`}
                          style={{
                            color: likedImages[index] ? "var(--color-primary-500)" : "var(--color-gray-600)",
                          }}
                          aria-hidden="true"
                        />
                      </button>
                      <button
                        type="button"
                        className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
                        onClick={() => openSlider(index)}
                        aria-label="View fullscreen"
                      >
                        <FontAwesomeIcon icon={faExpand} className="text-sm" style={{ color: "var(--color-gray-600)" }} aria-hidden="true" />
                      </button>
                    </div>

                    {/* Primary Color Category Badge */}
                    {product.category && (
                      <div className="absolute top-3 left-3">
                        <span 
                          className="px-3 py-1.5 backdrop-blur-sm text-white text-xs font-semibold rounded-full shadow-lg bell-mt-primary"
                          style={{
                            backgroundColor: "var(--color-primary-500)",
                          }}
                          itemProp="keywords"
                        >
                          {product.category}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Image Info Footer */}
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <h3 
                          id={`image-title-${index}`} 
                          className="font-medium text-gray-800 truncate bell-mt-primary"
                          style={{ color: "var(--color-gray-800)" }}
                          itemProp="name"
                        >
                          {product.title}
                        </h3>
                        <div className="flex items-center gap-2 mt-1">
                          {product.category && (
                            <span 
                              className="text-xs px-2 py-0.5 rounded bell-mt-primary"
                              style={{
                                backgroundColor: "var(--color-primary-500)",
                                color: "var(--color-white)",
                              }}
                            >
                              {product.category}
                            </span>
                          )}
                          {likedImages[index] && (
                            <span className="text-xs flex items-center gap-1 bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
                              <FontAwesomeIcon icon={faHeart} className="text-xs" aria-hidden="true" />
                              Liked
                            </span>
                          )}
                        </div>
                        {product.description && (
                          <p className="text-sm mt-2 line-clamp-2 inter-secondary" style={{ color: "var(--color-gray-600)" }} itemProp="description">
                            {product.description}
                          </p>
                        )}
                      </div>
                      <button
                        type="button"
                        className="w-8 h-8 rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 bell-mt-primary"
                        style={{
                          backgroundColor: "var(--color-primary-500)",
                          color: "var(--color-white)",
                        }}
                        onClick={() => openSlider(index)}
                        aria-label={`View details of ${product.title || 'image'}`}
                      >
                        <FontAwesomeIcon icon={faEye} className="text-sm" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </section>
          ) : (
            /* Empty State */
            <section className="text-center py-20" aria-labelledby="empty-state-title">
              <div 
                className="w-32 h-32 rounded-3xl flex items-center justify-center mx-auto mb-8 border-2"
                style={{
                  background: "linear-gradient(135deg, var(--color-primary-100), var(--color-primary-50))",
                  borderColor: "var(--border-primary-20)",
                }}
                aria-hidden="true"
              >
                <FontAwesomeIcon icon={faSearch} className="text-5xl" style={{ color: "var(--color-primary-400)" }} />
              </div>
              <h2 id="empty-state-title" className="text-2xl font-bold mb-3 bell-mt-primary" style={{ color: "var(--color-gray-800)" }}>
                No images found
              </h2>
              <p className="mb-8 max-w-md mx-auto inter-secondary" style={{ color: "var(--color-gray-600)" }}>
                Try adjusting your search terms or filter categories to find what you're looking for.
              </p>
              <div className="flex flex-wrap gap-3 justify-center">
                <button
                  type="button"
                  onClick={() => setSearchTerm('')}
                  className="px-5 py-2.5 text-white font-medium rounded-xl hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 bell-mt-primary"
                  style={{
                    background: "var(--gradient-primary)",
                  }}
                >
                  Clear Search
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setSearchTerm('');
                    setFilterCategory('all');
                  }}
                  className="px-5 py-2.5 font-medium rounded-xl border hover:shadow-md transition-all duration-300 bell-mt-primary"
                  style={{
                    backgroundColor: "var(--color-white)",
                    color: "var(--color-primary-600)",
                    borderColor: "var(--border-primary-20)",
                  }}
                >
                  Reset All Filters
                </button>
              </div>
            </section>
          )}

          {/* Pagination (Optional - Add if you have many images) */}
          {filteredProducts.length > 0 && filteredProducts.length < products.length && (
            <nav aria-label="Gallery navigation" className="mt-12">
              <p className="text-center mb-4 inter-secondary" style={{ color: "var(--color-gray-600)" }}>
                Showing {filteredProducts.length} of {products.length} images
              </p>
            </nav>
          )}
        </main>

        {/* Scroll to Top Button */}
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className={`fixed bottom-6 right-6 w-14 h-14 text-white rounded-full flex items-center justify-center shadow-xl hover:shadow-2xl hover:scale-110 transition-all duration-300 ${
            showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
          }`}
          style={{
            background: "var(--gradient-primary)",
          }}
          aria-label="Scroll back to top"
        >
          <FontAwesomeIcon icon={faChevronUp} aria-hidden="true" />
        </button>
        

        {/* Full Screen Slider */}
        {isSliderOpen && (
          <FullScreenSlider
            images={filteredProducts.map(p => p.imgg)}
            initialIndex={currentImageIndex}
            onClose={closeSlider}
          />
        )}
      </div>
    </>
  );
}

// Helper component for meta tags (if not using react-helmet, you can use react-helmet-async)
const Helmet = ({ children }) => {
  // In a real app, use react-helmet or similar
  return null;
};

// IMPORTANT: Update the export to match the new component name
export default ImageGallery;